import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import TaxPayer from "../../models/tax-payer";
import TaxPayerLimitsForm from "./TaxPayerLimitsForm";

interface TaxPayerLimitsModalProps {
  show: boolean;
  taxPayer?: TaxPayer;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const TaxPayerLimitsModal: React.FC<TaxPayerLimitsModalProps> = ({
  show,
  taxPayer,
  onCancel,
  onSuccess,
}) => {
  const modalTitle = taxPayer
    ? `Editar límites para Contribuyente: ${taxPayer.socialName}`
    : `Crear límites para Contribuyente`;

  const onClose = () => {
    onCancel();
  };

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          {show ? (
            <TaxPayerLimitsForm
              taxPayer={taxPayer}
              onCancel={onCancel}
              onSuccess={onSuccess}
              clearOnSuccess={false}
            />
          ) : (
            <></>
          )}
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default TaxPayerLimitsModal;
